module.exports = __webpack_public_path__ + "img/accountant-4008603_640.95b7bc98.jpg";